import React, { useEffect, useState } from "react";
import axios from "axios";
import { useForm } from "react-hook-form";
import { Link, useNavigate } from "react-router-dom";
import swal from "sweetalert";
import KeyboardArrowLeftOutlinedIcon from "@mui/icons-material/KeyboardArrowLeftOutlined";
import AnimatedPage from "../components/AnimatedPage";
import Header from "../components/Header";
import Footer from "../components/Footer";

function AddBank() {
    const [profile, setProfile] = useState(JSON.parse(localStorage.getItem("profile")));
    const [show, setShow] = useState(false);
    const [load, setLoad] = useState(false);
    const [bank, setBank] = useState(null);
    const navigate = useNavigate();

    const handleBackClick = () => {
        navigate(-1);
    };

    axios.interceptors.request.use(
        (config) => {
            const token = localStorage.getItem("user");
            if (token) {
                config.headers["Authorization"] = `Bearer ${token}`;
            }
            return config;
        },
        (error) => {
            return Promise.reject(error);
        }
    );

    const {
        register,
        handleSubmit,
        setError,
        formState: { errors }
    } = useForm();

    useEffect(() => {
        axios
            .get(`${process.env.REACT_APP_API_URL}/auth/getUser`, {})
            .then((res) => {
                if (profile !== res.data.data) {
                    setProfile(res.data.data);
                    localStorage.setItem("profile", JSON.stringify(res.data.data));
                }
            })
            .catch((err) => localStorage.removeItem("user"));
            
        axios
            .get(`${process.env.REACT_APP_API_URL}/bank/getBank`, {})
            .then((res) => {
                setBank(res.data.data);
                setLoad(true);
            })
            .catch((err) => {
                setLoad(true);
                setBank(null);
            });
    }, []);

    const onSubmit = (data) => {
        const formData = {
            name_bank: data.name_bank,
            stk: data.stk,
            fullname: data.fullname,
            user: profile._id
        };
        axios
            .post(`${process.env.REACT_APP_API_URL}/bank/create`, formData)
            .then((res) => {
                swal("Thành Công", "Ngân hàng đã được thêm thành công", "success");
                navigate("/profile");
            })
            .catch((err) => swal("Thất bại", err.response?.data?.message !== "internal server error" ? err.response.data.message : "Đã có lỗi xảy ra", "error"));
    };

    // Hàm ẩn 4 số cuối của Số tài khoản
    const maskBankAccount = (stk) => {
        if (!stk) return "";
        if (stk.length <= 4) return "****";
        return stk.slice(0, -4) + "****";
    };

    return (
        <AnimatedPage>
            <Header profile={profile} />

            <style>{`
                html, body, #root {
                    height: auto !important;
                    min-height: 100vh;
                    overflow-y: auto !important;
                    background-color: #e3e1e2 !important; 
                    margin: 0; padding: 0;
                }
                
                .addbank-wrapper {
                    padding-bottom: 100px;
                    background-color: #e3e1e2;
                    min-height: 100vh;
                }

                /* ================================================== */
                /* 1. BANNER THÔNG TIN USER                           */
                /* ================================================== */
                .center-head {
                    width: 100%;
                    height: 180px;
                    background: url('https://dztwieyphe62d.cloudfront.net/content/images/main/user/banner-center.jpg') center top no-repeat;
                    background-size: cover;
                    padding: 0 20px; 
                    display: flex;
                    align-items: center; 
                    color: #fff;
                    box-shadow: 0 2px 5px rgba(0,0,0,0.2);
                }
                .profile-avatar-wrapper { position: relative; margin-right: 15px; flex-shrink: 0; }
                .profile-avatar { width: 65px; height: 65px; background-color: #fff; border-radius: 50%; display: flex; justify-content: center; align-items: center; }
                .profile-avatar i { font-size: 38px; color: #ffca28; }
                .profile-v1-badge { position: absolute; top: -2px; right: -5px; background-color: #ff9800; color: #fff; border-radius: 50%; width: 20px; height: 20px; display: flex; justify-content: center; align-items: center; font-size: 11px; font-weight: bold; border: 2px solid #222; }
                .profile-info { flex: 1; display: flex; flex-direction: column; justify-content: center; text-align: left; }
                .profile-info h3 { margin: 0 0 2px 0; font-size: 16px; font-weight: bold; color: #fff; }
                .profile-info p.email { margin: 0 0 6px 0; font-size: 13px; color: #ddd; }
                .profile-stats p { margin: 2px 0; font-size: 13px; color: #fff; }
                .profile-stats span { color: #ff9800; font-weight: bold; }

                /* ================================================== */
                /* 2. TIÊU ĐỀ TRANG                                   */
                /* ================================================== */
                .page-header-box {
                    display: flex;
                    align-items: center;
                    padding: 15px;
                    background: transparent;
                }
                .back-btn {
                    background: #fff;
                    color: #b71c1c;
                    width: 35px;
                    height: 35px;
                    border-radius: 50%;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    cursor: pointer;
                    box-shadow: 0 2px 4px rgba(0,0,0,0.1);
                    margin-right: 15px;
                }
                .back-btn:active { background: #f0f0f0; }
                .page-title-h1 {
                    font-size: 18px;
                    font-weight: bold;
                    color: #333;
                    margin: 0;
                    text-transform: uppercase;
                }

                /* ================================================== */
                /* 3. NỘI DUNG CHÍNH                                  */
                /* ================================================== */
                .addbank-content {
                    padding: 0 15px 20px 15px;
                }

                /* Nút thêm ngân hàng */
                .btn-add-bank-large {
                    width: 100%;
                    background: #fff;
                    color: #b71c1c;
                    border: 2px dashed #b71c1c;
                    padding: 15px;
                    border-radius: 8px;
                    font-size: 16px;
                    font-weight: bold;
                    cursor: pointer;
                    text-align: center;
                    margin-bottom: 20px;
                    transition: background 0.3s;
                }
                .btn-add-bank-large:active { background: #fbe9e9; }

                /* Thẻ ATM hiển thị ngân hàng đã liên kết */
                .bank-detail-card {
                    background: linear-gradient(135deg, #1e3c72 0%, #2a5298 100%);
                    color: #fff;
                    padding: 20px;
                    border-radius: 12px;
                    box-shadow: 0 4px 10px rgba(0,0,0,0.2);
                    margin-bottom: 20px;
                    cursor: pointer;
                    position: relative;
                    overflow: hidden;
                }
                .bank-detail-card::after {
                    content: "";
                    position: absolute;
                    top: -50%; right: -20%;
                    width: 150px; height: 150px;
                    background: rgba(255,255,255,0.1);
                    border-radius: 50%;
                }
                .bd-name { font-size: 18px; font-weight: bold; margin-bottom: 15px; text-transform: uppercase; letter-spacing: 1px; }
                .bd-stk { font-size: 22px; font-family: monospace; letter-spacing: 2px; margin-bottom: 10px; }
                .bd-owner { font-size: 14px; text-transform: uppercase; opacity: 0.9; }

                /* Form nhập liệu */
                .form-box { 
                    background: #fff; 
                    padding: 20px 15px; 
                    border-radius: 8px; 
                    box-shadow: 0 2px 6px rgba(0,0,0,0.1); 
                    margin-bottom: 20px;
                }
                .input-group { margin-bottom: 15px; }
                .input-group label { display: block; font-weight: bold; margin-bottom: 8px; color: #444; font-size: 13px; }
                .ipadd { 
                    width: 100%; padding: 12px 15px; border: 1px solid #ccc; 
                    border-radius: 5px; font-size: 14px; outline: none; background: #f9f9f9; color: #333;
                }
                .ipadd:focus { border-color: #b71c1c; background: #fff; }
                
                .btn-submit { 
                    width: 100%; background: #b71c1c; color: #fff; font-weight: bold; 
                    padding: 14px; border: none; border-radius: 5px; font-size: 16px; 
                    cursor: pointer; text-transform: uppercase; margin-top: 10px;
                }

                /* Box hướng dẫn / Chú ý */
                .huongdan { 
                    background: #fff; padding: 15px; border-radius: 8px; 
                    box-shadow: 0 2px 4px rgba(0,0,0,0.1); font-size: 13px; line-height: 1.6; color: #444; 
                }
                .huongdan .title { font-size: 15px; color: #b71c1c; margin-bottom: 10px; font-weight: bold; }
                .huongdan ul { padding-left: 20px; margin: 0; }
            `}</style>

            <div className="addbank-wrapper">
                
                
                {/* 2. TIÊU ĐỀ TRANG */}
                <div className="page-header-box">
                    
                    <h1 className="page-title-h1">Liên kết ngân hàng</h1>
                </div>

                {/* 3. NỘI DUNG */}
                <div className="addbank-content">
                    {load && (
                        <>
                            {/* FORM THÊM NGÂN HÀNG (Sẽ hiện khi bấm nút Thêm) */}
                            {show === true && (
                                <form className="form-box" onSubmit={handleSubmit(onSubmit)}>
                                    <div className="input-group">
                                        <label>Tên ngân hàng (VD: Vietcombank, MBBank)</label>
                                        <input
                                            className="ipadd"
                                            type="text"
                                            placeholder="Nhập tên ngân hàng"
                                            {...register("name_bank", { required: true })}
                                        />
                                    </div>
                                    <div className="input-group">
                                        <label>Số tài khoản</label>
                                        <input
                                            className="ipadd"
                                            type="number"
                                            placeholder="Nhập số tài khoản"
                                            {...register("stk", { required: true })}
                                        />
                                    </div>
                                    <div className="input-group">
                                        <label>Tên chủ tài khoản (Viết HOA không dấu)</label>
                                        <input
                                            className="ipadd"
                                            type="text"
                                            placeholder="NGUYEN VAN A"
                                            {...register("fullname", { required: true })}
                                        />
                                    </div>
                                    <button type="submit" className="btn-submit">
                                        Xác nhận
                                    </button>
                                </form>
                            )}

                            {/* DANH SÁCH NGÂN HÀNG ĐÃ LIÊN KẾT */}
                            {bank != null && bank.length > 0 ? (
                                <>
                                    {bank.map((item, index) => (
                                        <div 
                                            key={index}
                                            className="bank-detail-card" 
                                            onClick={() => swal("Chú ý", "Để chỉnh sửa thông tin ngân hàng vui lòng liên hệ CSKH", "info")}
                                        >
                                            <div className="bd-name">{item.name_bank}</div>
                                            {/* Đã thêm hàm maskBankAccount để ẩn 4 số cuối */}
                                            <div className="bd-stk">{maskBankAccount(item.stk)}</div>
                                            <div className="bd-owner">{item.fullname}</div>
                                        </div>
                                    ))}
                                    
                                    <div className="huongdan">
                                        <div className="title">Chú ý</div>
                                        <ul>
                                            <li>Thông tin liên kết ngân hàng phải tuyệt đối chính xác.</li>
                                            <li>Chúng tôi không chịu trách nhiệm cho sai sót liên quan đến ngân hàng của bạn.</li>
                                            <li>Để chỉnh sửa thông tin ngân hàng nếu bạn đã liên kết, vui lòng liên hệ CSKH.</li>
                                        </ul>
                                    </div>
                                </>
                            ) : (
                                /* NÚT THÊM NGÂN HÀNG KHI CHƯA CÓ */
                                <>
                                    {show === false && (
                                        <>
                                            <button 
                                                className="btn-add-bank-large"
                                                onClick={() => setShow(!show)}
                                            >
                                                + Thêm tài khoản ngân hàng
                                            </button>
                                        </>
                                    )}
                                </>
                            )}
                        </>
                    )}
                </div>
            </div>
            
            <Footer profile={profile} />
        </AnimatedPage>
    );
}

export default AddBank;